module.exports = __webpack_public_path__ + "media/images/pages/about_us/team_members/jennifer-0626e84683a95a61451c8aa58d444c81.png";